<template>
  <div class='AdmInput'>
    <label>{{ label }}</label>
    <input
    @input="e => $emit('returnValue', e.target.value)"
    type="text"
    :style="{ width: width }"
    />
  </div>
</template>

<script>
export default {
  name: 'AdmInput',
  props: {
    width: {
      type: String,
      default: '200px'
    },
    label: {
      type: String,
      default: 'Label'
    }
  }
}
</script>

<style scoped>
.AdmInput {
  text-align: left;
}
label {
  display: block;
  font-size: 12px;
  padding-bottom: 2px;
  color: #a6b1ba
}
input {
  font-size: 16px;
  padding: 7px;
  border: thin solid #a6b1ba;
  border-radius: 5px;
}
input:focus {
  outline: none;
}
</style>
